var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBritishFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_26488)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_308_26488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.27271 -0.204544H21.2728V18.2045H-3.27271V-0.204544Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.396285 -0.204544L8.96167 6.73722L18.2813 -0.204544H21.2728V2.1733L12.0682 9.03835L21.2728 15.8651V18.2045H18.2046L9.00002 11.3395L-0.166171 18.2045H-3.27271V15.9034L5.89349 9.07671L-3.27271 2.25V-0.204544H-0.396285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9887 10.5724L21.2728 16.6705V18.2045L10.8793 10.5724H12.9887ZM5.93184 11.3395L6.16195 12.6818L-1.20168 18.2045H-3.27271L5.93184 11.3395ZM21.2728 -0.204544V-0.0894872L11.723 7.12074L11.7997 5.43324L19.3551 -0.204544H21.2728ZM-3.27271 -0.204544L5.89349 6.54546H3.59235L-3.27271 1.40625V-0.204544Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97019 -0.204544V18.2045H12.1066V-0.204544H5.97019ZM-3.27271 5.93182V12.0682H21.2728V5.93182H-3.27271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.27271 7.19744V10.8793H21.2728V7.19744H-3.27271ZM7.19747 -0.204544V18.2045H10.8793V-0.204544H7.19747Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_26488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_308_26488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5455,
    height: 18.4091,
    fill: "white",
    transform: "translate(-3.27271 -0.204544)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritishFlag);
export default __webpack_public_path__ + "static/media/british-flag.381b68ec1807fd2689c8c2143d097ebf.svg";
export { ForwardRef as ReactComponent };